<template>
    <div>
        <div class="footer" v-if="bodyW > 900">
            <div class='left'>
                <img :src='"https://iboran.com/"+footerImg' class='logo' style="width: 255px !important;"/>
                <div style="height: 20%; min-height: 40px;">
                    <p class="tit">公司地址：</p>
                    <p>{{corporateInfor.address}}</p>
                </div>
                <div style="height: 23px; min-height: 40px;">
                    <p class="tit">联系电话：</p>
                    <p>{{corporateInfor.phone}}</p>
                </div>
                <div style="height: 23px; min-height: 40px;">
                    <p class="tit">联系手机：</p>
                    <p>{{corporateInfor.mobile}}</p>
                </div>
                <div style="height: 23px; min-height: 40px;">
                    <p class="tit">公司官网：</p>
                    <p style="cursor: pointer" @click='toPath("/#/index")'>http://www.{{domain}}</p>
                </div>
            </div>
            <div class='right'>
                <div class='r_1'>
                    热门产品
                    <div class='awsa'>
                        <div>
                            <div @click='toPath("/#/u8")'>用友U8 cloud</div>
                            <div @click='toPath("/#/u9")'>用友U9 cloud</div>
                            <div @click='toPath("/#/nc")'>用友NC cloud</div>
                            <div @click='toPath("/#/ys")'>用友YonSuite</div>
                            <div @click='toPath("/#/bip")'>用友Yon BIP</div>
                            <div @click='toPath("/#/erp")'>用友制造业ERP</div>
                        </div>
                    </div>
                </div>

                <div class='r_1'>
                    领域云
                    <div class='awsa'>
                        <div style="display: flex; flex-wrap: wrap;">
                            <div class="child-t" @click='toPath("/#/cwy")'>财务云</div>
                            <div class="child-t" @click='toPath("/#/gyl")'>供应链云</div>
                            <div class="child-t" @click='toPath("/#/rly")'>人力云</div>
                            <div class="child-t" @click='toPath("/#/zcy")'>资产云</div>
                            <div class="child-t" @click='toPath("/#/xty")'>协同云</div>
                            <div class="child-t" @click='toPath("/#/czy")'>财资云</div>
                            <div class="child-t" @click='toPath("/#/yxy")'>营销云</div>
                            <div class="child-t" @click='toPath("/#/jzy")'>建筑云</div>
                            <div class="child-t" @click='toPath("/#/cgy")'>采购云</div>
                            <!--                        <div style="padding: 0 18px 0 0;" onclick='toPath("/#/zzy")'>制造云</div>-->
                            <div class="child-t" @click='toPath("/#/swy")'>税务云</div>

                        </div>
                    </div>
                </div>

                <div class='r_1'>
                    数智化场景
                    <div class='awsa'>
                        <div  style="
    display: flex;
    flex-wrap: wrap;
">
                            <div class="child-t" @click='toPath("/#/xmzz")'>项目制造</div>
                            <div class="child-t" @click='toPath("/#/zncw")'>智能财务</div>
                            <div class="child-t" @click='toPath("/#/zjtx")'>专精特新</div>
                            <div class="child-t" @click='toPath("../../../static/home/Zhuanq/cwgx.html")'>财务共享</div>
                            <div class="child-t" @click='toPath("/#/yylt")'>医药流通</div>
                            <div class="child-t" @click='toPath("../../../static/home/Quanqiusiku/qqsk.html")'>全球司库</div>
                            <div class="child-t" @click='toPath("/#/y_zhxt")'>智慧协同</div>
                            <div class="child-t" @click='toPath("../../../static/home/Zhuanq/bbhb.html")'>合并报表</div>
                            <div class="child-t" @click='toPath("/#/y_szzc")'>数智资产</div>
                            <div class="child-t" @click='toPath("/#/szrl")'>数字人力</div>
                            <div class="child-t" @click='toPath("/#/y_hgsw")'>合规税务</div>
                            <div class="child-t" @click='toPath("/#/qyjr")'>企业金融</div>
                            <!--                        <div @click='toPath("/#/gxhdz")'>个性化定制</div>-->
                            <!--                        <div @click='toPath("/#/sjzz")'>设计制造一体化</div>-->
                        </div>
                    </div>
                </div>
                <div class='r_1'>
                    客户案例
                    <div class='awsa'>
<!--                        <div>-->
<!--                            <div @click='toPath("/#/al?type=1")'>制造业</div>-->
<!--                            <div @click='toPath("/#/al?type=2")'>现代服务业</div>-->
<!--                            <div @click='toPath("/#/al?type=4")'>餐饮行业</div>-->
<!--                            <div @click='toPath("/#/al?type=3")'>医药行业</div>-->
<!--                            <div @click='toPath("/#/lshy")'>零售行业</div>-->
<!--                            <div @click='toPath("/#/al?type=5")'>汽配行业</div>-->
<!--                            &lt;!&ndash;                        <div @click='toPath("/#/al?type=6")'>电子信息行业</div>&ndash;&gt;-->
<!--                        </div>-->
                        <div class="child-t2"  v-for='(item2,index2) in menuList' :key='index2'>
                            <div @click='toPath("/#/al?type="+(item2.scode))'>{{item2.name}}</div>
                        </div>
                    </div>
                </div>

                <div class='r_1'>
                    关于我们
                    <div class='awsa'>
                        <div>
                            <div @click='toPath("/#/we?index=1")'>关于泊冉</div>
                            <div @click='toPath("/#/we?index=2")'>产品资讯</div>
                            <div @click='toPath("/#/we?index=2")'>人才招聘</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="footer2" v-if="bodyW < 900">
            <div style="padding: 10px 10px 2% 0 !important">
                <img :src="'https://iboran.com/'+footerImg" class='logo' style="width: 255px !important;"/>
                <div style="height: 23%; min-height: 40px;">
                    <p class="tit" style="color: #fff !important;">公司地址：</p>
                    <p style="color: #fff !important;">{{corporateInfor.address}}</p>
                </div>
                <div style="height: 23px; min-height: 40px;">
                    <p class="tit" style="color: #fff !important;">联系电话：</p>
                    <p style="color: #fff !important;">{{corporateInfor.phone}}</p>
                </div>
                <div style="height: 23px; min-height: 40px;">
                    <p style="color: #fff !important;" class="tit">联系手机：</p>
                    <p style="color: #fff !important;">{{corporateInfor.mobile}}</p>
                </div>
                <div style="height: 23px; min-height: 40px;">
                    <p style="color: #fff !important;" class="tit">公司官网：</p>
                    <p style="color: #fff !important;">http://www.{{domain}}</p>
                </div>
            </div>
            <div class="right_f">
                <ul>
                    <li>
                        <div class='awsa_1'>
                            <div class="f_1" @click="openNav(item1)" style="color: #fff !important;">热门产品
                                <img src="https://www.yonsuite.com/product/images/mobile/m_04.png" style="width: 10px !important; float: right;"/>
                                <div class='awsa_1_1'
                                     style="font-size: 14px"
                                     :style="item1 != false ? 'display: block;' : 'display: none;'">
                                    <div @click='toPath("/#/u8")' style="color: #fff !important;">用友U8 cloud</div>
                                    <div @click='toPath("/#/u9")' style="color: #fff !important;">用友U9 cloud</div>
                                    <div @click='toPath("/#/nc")' style="color: #fff !important;">用友NC cloud</div>
                                    <div @click='toPath("/#/ys")' style="color: #fff !important;">用友YonSuite</div>
                                    <div @click='toPath("/#/bip")' style="color: #fff !important;">用友Yon BIP</div>
                                    <div @click='toPath("/#/erp")' style="color: #fff !important;">用友制造业ERP</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>

                        <div class='awsa_2'>
                            <div class="f_2" style="color: #fff !important;" @click="openNav2(item2) ">领域云
                                <img src="https://www.yonsuite.com/product/images/mobile/m_04.png" style="width: 10px !important; float: right;"/>
                                <div style="display: flex; flex-wrap: wrap;font-size: 14px" class='awsa_2_2'
                                     :style="item2 != false ? 'display: block;' : 'display: none;'">
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/cwy")'>财务云</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/gyl")'>供应链云</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/rly")'>人力云</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/zcy")'>资产云</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/xty")'>协同云</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/czy")'>财资云</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/yxy")'>营销云</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/jzy")'>建筑云</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/cgy")'>采购云</div>
                                    <!--                        <div style="padding: 0 18px 0 0;" onclick='toPath("/#/zzy")'>制造云</div>-->
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/swy")'>税务云</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class='awsa_3'>
                            <div class="f_3" @click="openNav3(item3)">数智化场景
                                <img src="https://www.yonsuite.com/product/images/mobile/m_04.png" style="width: 10px !important; float: right;"/>

                                <div style="display: flex;flex-wrap: wrap;font-size: 14px" class='awsa_3_3'
                                     :style="item3 != false ? 'display: block;' : 'display: none;'">
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/xmzz")'>项目制造</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/zncw")'>智能财务</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/zjtx")'>专精特新</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("../../../static/home/Zhuanq/cwgx.html")'>财务共享</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/yylt")'>医药流通</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("../../../static/home/Quanqiusiku/qqsk.html")'>全球司库</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/y_zhxt")'>智慧协同</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("../../../static/home/Zhuanq/bbhb.html")'>合并报表</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/y_szzc")'>数智资产</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/szrl")'>数字人力</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/y_hgsw")'>合规税务</div>
                                    <div style="color: #fff !important;" class="child-t" @click='toPath("/#/qyjr")'>企业金融</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class='awsa_4'>
                            <div class="f_4" style="color: #fff !important;" @click="openNav4(item4)">客户案例
                                <img src="https://www.yonsuite.com/product/images/mobile/m_04.png" style="width: 10px !important; float: right;"/>

                                <div class='awsa_4_4'
                                     style="font-size: 14px"
                                     :style="item4 != false ? 'display: block;' : 'display: none;'">
<!--                                    <div style="color: #fff !important;" @click='toPath("/#/al?type=1")'>制造业</div>-->
<!--                                    <div style="color: #fff !important;" @click='toPath("/#/al?type=2")'>现代服务业</div>-->
<!--                                    <div style="color: #fff !important;" @click='toPath("/#/al?type=4")'>餐饮行业</div>-->
<!--                                    <div style="color: #fff !important;" @click='toPath("/#/al?type=3")'>医药行业</div>-->
<!--                                    <div style="color: #fff !important;" @click='toPath("/#/lshy")'>零售行业</div>-->
<!--                                    <div style="color: #fff !important;" @click='toPath("/#/al?type=5")'>汽配行业</div>-->
<!--                                    &lt;!&ndash;                        <div onclick='toPath("/#/al?type=6")'>电子信息行业</div>&ndash;&gt;-->

                                    <div  v-for='(item2,index2) in menuList' :key='index2'>
                                        <div @click='toPath("/#/al?type="+(item2.scode))'>{{item2.name}}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </li>
                    <li>
                        <div class='awsa_5'>
                            <div class="f_5" style="color: #fff !important;" @click="openNav5(item5)">关于我们
                                <img src="https://www.yonsuite.com/product/images/mobile/m_04.png" style="width: 10px !important; float: right;"/>

                                <div class='awsa_5_5'
                                     style="font-size: 14px"
                                     :style="item5 != false ? 'display: block;' : 'display: none;'">
                                    <div style="color: #fff !important;" @click='toPath("/#/we?index=1")'>关于泊冉</div>
                                    <div style="color: #fff !important;" @click='toPath("/#/we?index=2")'>产品资讯</div>
                                    <div style="color: #fff !important;" @click='toPath("/#/we?index=2")'>人才招聘</div>
                                </div>
                            </div>

                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>


</template>

<script>
import axios from 'axios'
export function uploadAction(url,parameter){
    return axios({
        url: url,
        data: parameter,
        method:'GET' ,
        headers: {
            'Content-Type': 'multipart/form-data',  // 文件上传
        },
    })
}

export default {
    name: 'footer',
    data() {
        return {
            navConf:{
                leftCur:null,
                popShow:false,
            },
            item1: false,
            item2: false,
            item3: false,
            item4: false,
            item5: false,
            bodyW: '',
            footerImg: '',
            domain: '',
            corporateInfor: [],
            menuList: [],
        }
    },
    mounted() {
        window.addEventListener('resize', this.nresize);
        // console.log( document.body.clientWidth, '111111111ffffffffff-------bbbbbbbbbb--------------wwwwwwwwww')
        this.bodyW = document.body.clientWidth;
    },
    beforeDestroy(){
        // console.log( document.body.clientWidth, 'documentElement-------bbbbbbbbbb--------------wwwwwwwwww')
        window.removeEventListener('resize', this.nresize);
    },
    methods:{
        nresize(){
            this.bodyW = document.body.clientWidth
        },
        openNav(item){
            this.item1 = !item
        },
        openNav2(item){
            this.item2 = !item
        },
        openNav3(item){
            this.item3 = !item
        },
        openNav4(item){
            this.item4 = !item
        },
        openNav5(item){
            this.item5 = !item
        },
        toPath(url,query) {
            window.open(url);
        },
        getImg() {
            // api.php/cms/site
            this.footerImg = ''
            uploadAction(`https://iboran.com/api.php/cms/company`).then(res => {
                // console.log(res.data.data, 'hhhhhhhhhhhh-----------hhhhhhhh')
                // localStorage.setItem('img', res.data.data.weixin);
                this.footerImg = res.data.data.weixin
                this.corporateInfor = res.data.data
            }).catch(err => {
                alert(err.message)
            })
        },
        getHeaderImg() {
            uploadAction(`https://iboran.com/api.php/cms/site`).then(res => {
                // console.log(res.data.data, 'hhhhhhhhhhhh-----------hhhhhhhh')
                this.domain = res.data.data.domain
            }).catch(err => {
                alert(err.message)
            })
        },
        getMenuNav() {
            this.menuList = []
            uploadAction(`https://iboran.com/api.php/cms/nav`).then(res => {
                this.menuList = res.data.data[3].son
            }).catch(err => {
                alert(err.message)
            })
        },
    },
    created() {
        this.getImg()
        this.getHeaderImg()
        this.getMenuNav()
    },
   }
</script>
<style scoped lang="scss">
.footer2{
    background: #3644b9;
    padding: 40px 80px;
    //display: flex;
    height: 100%;
    overflow: hidden;
    color: #fff;
    .tit{
        float: left;
    }
    .logo{
        padding-bottom: 3%;
    }
    .child-t{
        width: 110px;
    }
}
.open{
    display: block;
}
.awsa_1{
    border-bottom: 1px solid #fff;
}
.awsa_2{
    border-bottom: 1px solid #fff;
}
.awsa_3{
    border-bottom: 1px solid #fff;
}
.awsa_4{
    border-bottom: 1px solid #fff;
}
.awsa_5{
    border-bottom: 1px solid #fff;
}
.awsa_1_1{
    display: none;
    padding: 1% 0 1% 2%;
    >div{
        padding-bottom: 1%;
    }
}
.awsa_2_2{
    display: none;
    padding: 1% 0 1% 2%;
    >div{
        padding-bottom: 1%;
    }
}
.awsa_3_3{
    display: none;
    padding: 1% 0 1% 2%;
    >div{
        padding-bottom: 1%;
    }
}
.awsa_4_4{
    display: none;
    padding: 1% 0 1% 2%;
    >div{
        padding-bottom: 1%;
    }
}
.awsa_5_5{
    display: none;
    padding: 1% 0 1% 2%;
    >div{
        padding-bottom: 1%;
    }
}
.f_1{
    font-size: 16px;
    padding: 1% 0;
}
.f_2{
    font-size: 16px;
    padding: 1% 0;
}
.f_3{
    font-size: 16px;
    padding: 1% 0;
}
.f_4{
    font-size: 16px;
    padding: 1% 0;
}
.f_5{
    font-size: 16px;
    padding: 1% 0;
}
.right_f>ul{
    list-style:none
}
</style>
<style lang="scss" scoped>
    .footer{
        //width: 100% ;

        background: #3644b9;
        padding: 2% 4%;
        display: flex;
        .left{
            width: 24% !important;
            border-right: 1px solid #ffffff;
            padding: 1 2% 0;
            >img{
                width: 100%;
                height: 50px;
            }
            div{
                font-size: 16px;
                color: #ffffff;
                margin-top: 13px;
            }
        }
        .right{
            //width: 80% !important;
            display: flex;
            color: #ffffff;
            flex: 1;
            margin-left: 50px;
            font-size: 18px;
            .r_1{
                //width: 20%;
                .awsa{
                    display: flex;
                    margin-top: 30px;
                    text-align: center;
                    flex-wrap: wrap;
                    >div{
                        //width: 260px;
                        >div{
                            margin-bottom: 10px;
                            color: #eaeaea;
                            font-size: 14px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    .r_1:nth-of-type(1){
        width: 10%;
        text-align: center;
        padding-right: 6%;
        min-width: 100px;
        .awsa{
            padding-left: 2%;
        }
    }
    .r_1:nth-of-type(2){
        width: 18%;
        padding-right: 4%;
        text-align: center;
        min-width: 200px;
        max-width: 23%;
        .awsa{
            padding-left: 14%;
        }
    }
    .r_1:nth-of-type(3){
        width: 18%;
        padding-right: 6%;
        text-align: center;
        min-width: 200px;
        .awsa{
            padding-left: 14%;
        }
    }
    .r_1:nth-of-type(4){
        width: 16%;
        min-width: 200px;
        text-align: center;
        .awsa{
            padding-left: 2%;
        }
    }
    .r_1:nth-of-type(5){
        width: 8%;
        text-align: center;
        min-width: 75px;
        padding-left: 3%;
        .awsa{
            padding-left: 12%;
        }
    }
    .footer .left div .tit{
        width: 84px;
        height: 100%;
        float: left;
    }
    .child-t{
        width: 60px;
        padding: 0 18px 0 0;
    }
    .child-t2{
        width: 71px;
        padding: 0 18px 0 0;
    }
    @media all and (max-width: 980px) {
        .footer2{
            width: 90%;
            padding: 40px 20px;
            //max-width:100%; margin:0 auto;
            //width: 86.6%;
        }
    }
    @media all and (min-width: 980px) {
        .footer2{
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue